import { useState, useEffect } from 'react';

export const useUrlValidation = ({ urlValue = '' }, validUrlPattern) => {
  const [hasUrl, sethasUrl] = useState(null);

  useEffect(() => {
    const vrbo = new RegExp(validUrlPattern);

    sethasUrl(vrbo.test(urlValue));
  }, [urlValue]);

  return [hasUrl];
};
